import React from 'react'

export default function PriorityColors(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18.05" height="18.05" viewBox="0 0 18.05 18.05">
      <rect width="100%" height="100%" fill={props.fill}></rect>
    </svg>
  )
}
